<template>
  <div
    class="banner"
    :style="{ background: `url(${bgUrl}) no-repeat center / cover` }"
  >
    <div
      v-if="$route.name === 'qyzcList'"
      class="banner-container qyzcList def-w"
    >
      <div class="title"><span class="fc">精选</span>企业专场</div>
      <div class="desc">
        企业专场是化云闲余平台针对大型国企、央企及规模较大民营企业的资产处置痛点，量身打造的专属化、定制化资产处置渠道。
        其核心是打破传统多企业资产混杂处置的模式，将单一企业旗下的废旧生产设备、闲置办公物资、低效运营资产等各类待盘活
        资产进行统一归集、分类梳理后集中展示并开展交易。
      </div>
    </div>
    <div
      v-if="$route.name === 'nbtp'"
      class="banner-container qyzcDetail def-w"
    >
      <div class="title">内部调配 · 资源共享</div>
      <div class="desc">信息透明 · 交易规范 · 高速高效 · 安全稳定</div>
    </div>
    <div
      v-if="$route.name === 'qyzcDetail'"
      class="banner-container qyzcDetail def-w"
    >
      <div class="title">{{ qyzcName }} · 闲余物资处置专区</div>
      <div class="desc">信息透明 · 交易规范 · 高速高效 · 安全稳定</div>
    </div>
    <div
      v-if="$route.name === 'gwczl'"
      class="banner-container qyzcDetail def-w"
    >
      <div class="title">国有企业 · 公务用车处置专区</div>
      <div class="desc">信息透明 · 交易规范 · 高速高效 · 安全稳定</div>
    </div>
  </div>
</template>

<script>
import { BANNER_CONFIG } from "@/utils/constant";

export default {
  name: "LayoutBanner",
  props: {},
  components: {},
  data() {
    return {
      BANNER_CONFIG,
      qyzcName: "",
    };
  },
  computed: {
    bgUrl() {
      return BANNER_CONFIG[this.$route.name];
    },
  },
  created() {
    this.getQyzcName();
  },
  watch: {
    $route: "getQyzcName",
  },
  mounted() {},
  methods: {
    getQyzcName() {
      this.qyzcName =
        JSON.parse(localStorage.getItem("qyzcInfo"))?.subtitle || "";
    },
  },
};
</script>

<style scoped lang="scss">
.banner {
  width: 100%;
  height: 360px;
  overflow: hidden;

  .banner-container {
    height: fit-content;
    .title {
      margin-top: 100px;
      font-weight: bold;
      font-size: 48px;
      color: #fff;
    }
    .desc {
      margin-top: 30px;
      width: 775px;

      color: #ffffff;
      line-height: 24px;
    }
  }

  .qyzcDetail {
    .desc {
      margin-top: 36px;
      font-size: 30px;
    }
  }
}
</style>
